import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import DrawerToggleButton from '../drawer-toggle-button';
import ContestFinalistStore from '../../stores/contest-finalist-store';
import { addFinalist, removeFinalist } from '../../actions/contest-finalist';
import { dismissOnboardingPrompt } from 'contest/actions/dismiss-onboarding-prompt';

const ConnectedContestsFinalistButton = connectToStores(
    DrawerToggleButton,
    [ContestFinalistStore],
    (context, { user, tooltip }) => {
        const store = context.getStore(ContestFinalistStore);

        const clearOnboardingFlag = () => {
            if (store.isShortlistStage()) {
                context.executeAction(dismissOnboardingPrompt, { key: 'finalist-button' });
            } else {
                context.executeAction(dismissOnboardingPrompt, { key: 'finalist-drawer' });
            }
        };

        return {
            isSelected: store.isFinalist(user.userId),
            isDisabled: !store.isFinalist(user.userId) && store.hasSelectedMaxFinalists(),
            isPrimary: store.isShortlistStage(),
            tooltip: tooltip,
            onAdd: () => {
                context.executeAction(addFinalist, user);
                clearOnboardingFlag();
            },
            onRemove: () => {
                context.executeAction(removeFinalist, user.userId);
                clearOnboardingFlag();
            },
        };
    }
);

ConnectedContestsFinalistButton.propTypes = {
    user: PropTypes.shape({
        userId: PropTypes.number.isRequired,
        avatarUrl: PropTypes.string.isRequired,
    }).isRequired,
    tooltip: PropTypes.string.isRequired,
};

ConnectedContestsFinalistButton.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func,
};

export default ConnectedContestsFinalistButton;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/connected/connected-contest-finalist-button.jsx